module.exports = __webpack_public_path__ + "static/media/journey-left-trees-in-front-of-hill.5eae160e.svg";